import { render, staticRenderFns } from "./CustomerConversationDetail.vue?vue&type=template&id=7c050d9a&scoped=true"
import script from "./CustomerConversationDetail.vue?vue&type=script&lang=js"
export * from "./CustomerConversationDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerConversationDetail.vue?vue&type=style&index=0&id=7c050d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c050d9a",
  null
  
)

export default component.exports